module.exports = __webpack_public_path__ + "img/34.543b24fc.jpg";